module.exports = __webpack_public_path__ + "static/media/IMG_0288.6d18ac23.jpg";